<div class="main-container">
  <div class="row-container" *ngIf="!confirmationView">
    <ion-col *ngIf="showEditIcon" [formGroup]="control" class="checkbox" size="1">
      <app-form-checkbox #checkBox (onChange)="toggleCheckBox()" [options]="checkBoxOptions"
      [formControlName] = "getFormControl('selected')">
      </app-form-checkbox>
  
    </ion-col>

    <ion-col [formGroup]="control" class="recurrent-data" [ngClass]="{'date-item': item == 'Date'}" size="2"
      *ngFor="let item of config">
   
      <app-form-date-picker  [showEditIcon]="showEditIcon" [ngClass]="{'delete-view':getFormControlValue('selected'), 'edit-recurring-modal': showEditIcon}" class="without-border-bottom w-100"  *ngIf="item=='Date'&&showEditIcon"
        [dateConfig]="dateConfig" [formControlName]="getFormControl(item)" [control]="control.get('date')">
      </app-form-date-picker>

      <ion-col *ngIf="item=='Date'&&!showEditIcon" class="recurrent-data" [ngClass]="{'date-item left-align': item == 'Date'}">
        {{showDate ? getFormControlValue('Date') : ''}}
      </ion-col>


      <div *ngIf="item=='Action' && showEditIcon" class="action-items">
        <i (click)="toggleCheckBox()" *ngIf="!getFormControlValue('selected')" class="fa fa-trash"></i>

        <i (click)="toggleCheckBox()" *ngIf="getFormControlValue('selected')" class="fa fa-undo"></i>

      </div>

      <div *ngIf="item=='Action' && !showEditIcon && showSlotActions" class="slot-action-items">
        <button type="button" (click)="removeSlot.emit()" *ngIf="canRemoveSlot"
                class="slot-btn remove-slot" title="Delete this shift">
          <i class="fas fa-trash-alt"></i>
        </button>

        <button type="button" (click)="addSlot.emit()" *ngIf="canAddSlot"
                class="slot-btn add-slot" title="Add another shift on this day">
          <i class="fas fa-plus"></i><span>Add shift</span>
        </button>
      </div>


      <app-form-select-v2 [ngClass]="{'delete-view':getFormControlValue('selected'), 'create-shift': currentView === 'create-shift', 'handle-chevron': !showEditIcon}" *ngIf="item!='Date' && item!='Action'" [placeholder]="item" [options]="getAvailableOptions(item)" [labelKey]="getLabelKey(item)"
        [control]="control.get(getFormControl(item))" [valueKey]="'value'" [returnObject]="true" [disableKey]="'disabled'"
        [formControlName]="getFormControl(item)" class="without-bottom-border" (onChange)="onValueChange($event,item)"
        [popupHeader]="item" [interfaceCssClass]="interfaceCssClass"></app-form-select-v2>

        
    </ion-col>
  </div>

  <div  class="row-container" *ngIf="confirmationView && !data">
    <ion-col class="recurrent-data" [ngClass]="{'date-item': item == 'Date', 'delete-view': getFormControlValue('selected')}" size="2" *ngFor="let item of config">
      {{getFormControlValue(item)}}
    </ion-col>
  </div>

  <div class="row-container"   *ngIf="confirmationView && data">
    <ion-col class="recurrent-data" [ngClass]="{'date-item': item == 'Date'}" size="2" *ngFor="let item of config">
      {{data[item]}}
    </ion-col>
  </div>

</div>